export interface RemoveLocationRequest {
    locationids: string[] | undefined;
    //isCalculateETA: boolean | undefined;
    connectionId : string | undefined;
  }
  